import { FontAwesomeIcon } from '@fortawesome/react-fontawesome';
import { faCloudArrowUp } from '@fortawesome/pro-regular-svg-icons';
import { useTranslation } from 'react-i18next';
import React, { forwardRef } from 'react';

import { UploadDropzoneProps } from '../vv-types';
import cn from 'core/utils/cn';
import useDragDetection from './use-drag-detection';

const UploadDropzone: React.FC<UploadDropzoneProps> = (
    { onFilesSelected },
    ref
) => {
    const { t } = useTranslation();
    const isDragging = useDragDetection();

    return (
        <label
            className={cn(
                'flex h-40 min-h-full gap-2.5 rounded-[10px] justify-center items-center font-semibold cursor-pointer',
                'bg-brand-escode-neonblue-neonblue-05 border-2 border-brand-escode-neonblue-neonblue-80 border-dashed text-brand-escode-neonblue-neonblue-100',
                isDragging && 'border-solid border-4'
            )}
            onDrop={onFilesSelected}
        >
            <FontAwesomeIcon icon={faCloudArrowUp} />
            <span>{t('file-uploader.title')}</span>
            <input
                ref={ref}
                type={'file'}
                multiple
                hidden
                onChange={onFilesSelected}
                data-testid="vv-uploader-dropzone-input"
            />
        </label>
    );
};

export default forwardRef(UploadDropzone);
